<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  created () {
    console.log('chart created')
  },
  mounted () {
    console.log('chart mounted')
    console.log('chart data', this.chartdata)
    this.renderChart(this.chartdata, this.options)
  }
}
</script>

<style>
</style>
